import React, { forwardRef, useCallback } from 'react'
import { Flex, HStack, Radio, RadioGroup } from '@chakra-ui/react'

export const FormAnswerLikert = forwardRef(
  (
    {
      likert,
      value,
      onChange,
      notApplicable,
      isInvalid,
      isRequired,
      isReadOnly,
      isDisabled,
      ...props
    },
    ref
  ) => {
    const handleChange = useCallback(
      value =>
        onChange?.({
          type: 'number',
          number: parseInt(value) || null,
          notApplicable: notApplicable && value === 'n/a'
        }),
      [onChange, notApplicable]
    )
    const radioValue = value ? `${value.notApplicable ? 'n/a' : value.number}` : null

    return (
      <Flex>
        <RadioGroup {...props} ref={ref} value={radioValue} onChange={handleChange}>
          <HStack>
            {[...Array(likert)].map((value, index) => (
              <Radio
                key={index}
                value={`${index + 1}`}
                isInvalid={isInvalid}
                isRequired={isRequired}
                isReadOnly={isReadOnly}
                isDisabled={isDisabled}>
                {index + 1}
              </Radio>
            ))}
            {notApplicable && (
              <Radio
                value='n/a'
                isInvalid={isInvalid}
                isRequired={isRequired}
                isReadOnly={isReadOnly}
                isDisabled={isDisabled}>
                N/A
              </Radio>
            )}
          </HStack>
        </RadioGroup>
      </Flex>
    )
  }
)

export const FormAnswerLikert3 = forwardRef((props, ref) => (
  <FormAnswerLikert {...props} ref={ref} likert={3} />
))

export const FormAnswerLikert5 = forwardRef((props, ref) => (
  <FormAnswerLikert {...props} ref={ref} likert={5} />
))

export const FormAnswerLikert7 = forwardRef((props, ref) => (
  <FormAnswerLikert {...props} ref={ref} likert={7} />
))
